import React, { useContext, useEffect, useState } from 'react'
import { handleRedirectInternal, currencyFormat } from '@/custom/common/components'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import { useFormik } from 'formik'
import { useHistory, useLocation } from 'react-router-dom'
import authContext from '@/product/context/auth/authContext'
import TertiaryButton from '@/custom/components/atoms/TertiaryButton'
import CustomDialog from '@/custom/components/organisms/Dialog'
import { Box, Button, Link, Modal, Typography } from '@material-ui/core'
import * as Yup from 'yup'
import { isValidHttpUrl, mapData } from '@/product/common/components'
import Timer from '@/custom/common/timer'
import BuynowContext from '@/product/context/buynow/buynowContext'
import { useTranslation } from 'react-i18next'
import SEO from '@/utils/SEO'
import { FALLBACK_IMAGE } from '@/utils'
import AlertContext from '@/product/context/alert/alertContext'
import StripeCardContext from '@/product/context/stripe/card/cardContext'
import SignContext from '@/custom/context/signContext'
import CustomTooltip from '../../organisms/CustomTooltip/CustomTooltip'

const Buynow = (props) => {
    const { isAuthenticated, user } = useContext(authContext)
    const { addToCart, responseStatus, clearResponse } = useContext(BuynowContext)
    const {
        get_all_card_details,
        getAllStripeCards,
        responseStatus: responseStatusCard,
        clearResponse: clearResponseCard,
    } = useContext(StripeCardContext)
    const [product, setProduct] = useState()
    const { t } = useTranslation()
    const { setAlert } = useContext(AlertContext)
    const [isInCart, setIsInCart] = useState(false)
    const history = useHistory()
    const location = useLocation()
    const { handleLoginPopup } = useContext(SignContext)
    const [toggleDialog, setToggleDialog] = useState(false)
    const [cardCount, setCardCount] = useState(0)
    const [toggleDialogCard, setToggleDialogCard] = useState(false)
    const [toggleDialogMobileVerification, setToggleDialogMobileVerification] = useState(false)

    const changeDialogStatusCard = () => {
        setToggleDialogCard(!toggleDialogCard)
    }

    const changeDialogStatusMobileVerification = () => {
        setToggleDialogMobileVerification(!toggleDialogMobileVerification)
    }

    useEffect(() => {
        if (get_all_card_details && get_all_card_details?.records?.length) {
            setCardCount(get_all_card_details.records.length)
        }
        return () => {
            setCardCount(0)
        }
    }, [get_all_card_details])

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    useEffect(() => {
        if (location.pathname.includes('product-view')) {
        }
        setProduct(props.data)
    }, [props.data])

    useEffect(() => {
        if (product) {
            formik.setFieldValue('product_id', product.id)
        }
    }, [product])

    const validationArray = Yup.object({
        product_id: Yup.number().required('Product id required'),
        qty: Yup.number().required('Enter quantity'),
    })

    const formik = useFormik({
        initialValues: { product_id: 0, qty: 0 },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (toggleDialog) {
                if (values.qty <= 0) {
                    setAlert('Select atleast 1 quantity', 'error')
                    setToggleDialog(false)
                    return
                }
                values.customCartFields = { source_type: 'buynow' }
                let cart = []
                cart.push(values)
                addToCart(
                    {
                        cart,
                        customBidData: {
                            location_id: parseInt(product?.location || 0),
                        },
                    },
                    'customAddToCart',
                )
                setIsInCart(true)
            } else {
                if (user?.restocking_fee_status) {
                    setAlert(`Restocking fee due. Please see cart.`, 'error')
                    // } else {
                    //     if (values.qty <= 0) {
                    //         setAlert('Select atleast 1 quantity', 'error')
                    //         setToggleDialog(false)
                    //         return
                    //     }
                    //     values.customCartFields = { source_type: 'buynow' }
                    //     let cart = []
                    //     cart.push(values)
                    //     addToCart(
                    //         {
                    //             cart,
                    //             customBidData: {
                    //                 location_id: parseInt(product?.location || 0),
                    //             },
                    //         },
                    //         'customAddToCart',
                    //     )
                    //     setIsInCart(true)
                    // }
                } else if (
                    user?.phone &&
                    user?.phone_verified === 1 &&
                    user?.phone !== '+1' &&
                    user?.phone !== '1' &&
                    user?.phone !== '+' &&
                    user?.phone !== '' &&
                    user?.phone !== null &&
                    user?.phone !== '+10' &&
                    user?.phone !== '0'
                ) {
                    // formik.setSubmitting(false)
                    if (values.qty <= 0) {
                        setAlert('Select atleast 1 quantity', 'error')
                        setToggleDialog(false)
                        return
                    }
                    values.customCartFields = { source_type: 'buynow' }
                    let cart = []
                    cart.push(values)
                    addToCart(
                        {
                            cart,
                            customBidData: {
                                location_id: parseInt(product?.location || 0),
                            },
                        },
                        'customAddToCart',
                    )
                    setIsInCart(true)
                } else {
                    setToggleDialogMobileVerification(true)
                }
            }
        },
    })
    const handleAddCart = () => {
        handleRedirectInternal(history, 'cart')
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.left = ''
        document.body.style.right = ''
        document.body.style.width = ''
    }
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'customAddToCart') {
                if (responseStatus.status === 'success') {
                    clearResponse()
                    setToggleDialog(false)
                    // setTimeout(() => {
                    //     handleRedirectInternal(history, 'buynowcart')
                    // }, 2000)
                }
            }
        }
    }, [responseStatus])
    const buynowQuantity = [
        {
            label: '',
            name: 'qty',
            type: 'number',
            placeholder: `${'Max quantity'} ${product ? product.qty - product.sold : 0}`,
            class: '',
            size: 'small',
            autoFocus: false,
            formik: formik,
        },
    ]

    useEffect(() => {
        if (product) {
            const selectedQty =
                product && product.qty - product.sold >= 1
                    ? parseInt(props?.selectedQty) >= 1
                        ? parseInt(props?.selectedQty)
                        : 1
                    : 0
            formik.values.qty = selectedQty
            formik.setFieldValue('qty', selectedQty)
        }
    }, [product, props?.selectedQty])
    const [isBuyOpen, setIsBuyOpen] = useState(false)
    const handleOpenBuy = () => {
        setIsBuyOpen(!isBuyOpen)
    }
    const isMobWidth = window.innerWidth <= 600

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        width: isMobWidth ? 'calc(100% - 50px)' : 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        cursor: 'pointer',
        p: 2,
        borderRadius: 10,
    }

    return (
        <>
            {/* <SEO title="Auction view" url={window.location.href} /> */}
            {product ? (
                <>
                    {(product.market_status === 'open' || product.market_status === 'closed') &&
                    product.wprice < product.bprice ? (
                        <form onSubmit={formik.handleSubmit}>
                            <div className="biddingCnt buynowCnt beforeLogin d-flex justify-content-center align-items-center">
                                {isAuthenticated ? (
                                    <>
                                        {product.market_status === 'open' && product.date_closed ? (
                                            <>
                                                {isInCart || product?.cart_id ? (
                                                    <PrimaryButton
                                                        label="View Cart"
                                                        btnSize="small vCart"
                                                        onClick={handleAddCart}
                                                    />
                                                ) : product.buynow ? (
                                                    <>
                                                        {props.isOnlyBuynowTile ? (
                                                            <div className="btnGroupBox">
                                                                <input
                                                                    className="buyNowinput"
                                                                    type="text"
                                                                    placeholder={`${currencyFormat(
                                                                        product.bprice *
                                                                            (props?.selectedQty
                                                                                ? props.selectedQty
                                                                                : 1),
                                                                    )}`}
                                                                    disabled
                                                                />
                                                                <PrimaryButton
                                                                    id="buy_now"
                                                                    label={'Buy Now'}
                                                                    type="submit"
                                                                    btnSize="small"
                                                                    disabled={props.disabled}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <PrimaryButton
                                                                    id="buy_now"
                                                                    label={`Buy Now ${currencyFormat(
                                                                        product.bprice *
                                                                            (props?.selectedQty
                                                                                ? props.selectedQty
                                                                                : 1),
                                                                    )}`}
                                                                    type="submit"
                                                                    btnSize="small"
                                                                    disabled={props.disabled}
                                                                />
                                                                <img
                                                                    className="infoIcon"
                                                                    src="/assets/svg/infoIcon.svg"
                                                                    onClick={handleOpenBuy}
                                                                />
                                                            </>
                                                        )}
                                                    </>
                                                ) : null}
                                            </>
                                        ) : (
                                            <PrimaryButton
                                                id="finished"
                                                label="Finished"
                                                btnSize="small"
                                            />
                                        )}{' '}
                                    </>
                                ) : (
                                    <>
                                        {product.market_status === 'open' && product.date_closed ? (
                                            <>
                                                {props.isOnlyBuynowTile ? (
                                                    <div className="btnGroupBox">
                                                        <input
                                                            className="buyNowinput"
                                                            type="text"
                                                            placeholder={`${currencyFormat(
                                                                product.bprice *
                                                                    (props?.selectedQty
                                                                        ? props.selectedQty
                                                                        : 1),
                                                            )}`}
                                                            disabled
                                                        />
                                                        <PrimaryButton
                                                            id="login_to_buy"
                                                            label={'Buy Now'}
                                                            btnSize="small"
                                                            onClick={handleLoginPopup}
                                                        />
                                                    </div>
                                                ) : (
                                                    <>
                                                        {' '}
                                                        <PrimaryButton
                                                            id="login_to_buy"
                                                            label={`Buy Now ${currencyFormat(
                                                                product.bprice *
                                                                    (props?.selectedQty
                                                                        ? props.selectedQty
                                                                        : 1),
                                                            )}`}
                                                            btnSize="small"
                                                            onClick={handleLoginPopup}
                                                        />
                                                        <img
                                                            className="infoIcon"
                                                            src="/assets/svg/infoIcon.svg"
                                                            onClick={handleOpenBuy}
                                                        />
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            <PrimaryButton
                                                id="finished"
                                                label="Finished"
                                                btnSize="small"
                                            />
                                        )}
                                    </>
                                )}
                            </div>
                        </form>
                    ) : null}
                </>
            ) : null}

            <CustomDialog
                title={
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            Buy Now <img src="/assets/svg/Info.svg" alt="" className="ml-3" />
                        </div>
                        <Button onClick={() => setToggleDialog(false)}>
                            <span className="material-icons">clear</span>
                        </Button>
                    </div>
                }
                open={toggleDialog}
                function={changeDialogStatus}
            >
                <div className="media make-offer-media">
                    <div className="media-left">
                        <img
                            className="cursorDecoy"
                            src={
                                isValidHttpUrl(props.data.avatar)
                                    ? props.data.avatar
                                    : `${global.site_url}/uploads/product/${props.data.avatar}`
                            }
                            onError={(e) => FALLBACK_IMAGE(e)}
                            alt={props.data.title}
                        />
                    </div>
                    <div className="media-body">
                        <h2 className="pv-pro-title">{props.data.title}</h2>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: props.data.desc_proc,
                            }}
                            className="pv-pro-descp"
                        ></div>
                        <div className="gridTimer">
                            <img src="/assets/svg/timer.svg" />
                            <Timer
                                date_added={props.data.date_added}
                                date_closed={props.data.date_closed}
                                withText={1}
                                endText="Time Left: "
                                startText="Starts in: "
                            ></Timer>
                        </div>
                    </div>
                </div>
                <div className="media pickup-media">
                    <img src="/assets/svg/cart-car.svg" alt="" className="media-left mr-3" />
                    <div className="media-body pickup-address">
                        <h6 className="checkoutHead m-0 mb-1">Pick up address</h6>
                        <div>{props?.productLocation?.full_address || ''}</div>
                    </div>
                </div>
                <div className="d-flex">
                    <PrimaryButton
                        id="buy_now_submit"
                        onClick={formik.handleSubmit}
                        type="submit"
                        btnSize="small"
                        label={`Buy now ${currencyFormat(
                            product?.bprice * (props?.selectedQty ? props.selectedQty : 1),
                        )}`}
                    />
                </div>
            </CustomDialog>
            <CustomDialog
                title={'No Cards Found'}
                open={toggleDialogCard}
                function={changeDialogStatusCard}
            >
                <h5>{"You don't have added any cards yet!"}</h5>
                <h5>{'Please add a card to continue Bidding'}</h5>
                <div className="actionWrapper">
                    <Button id="cancel" onClick={() => setToggleDialogCard(false)}>
                        {t('Cancel')}
                    </Button>
                    <PrimaryButton
                        id="add_card"
                        label="Continue"
                        btnSize="small"
                        onClick={() => handleRedirectInternal(history, 'payments/saved_cards')}
                    />
                </div>
            </CustomDialog>

            <CustomDialog
                // title={'Mobile Number Verification'}
                open={toggleDialogMobileVerification}
                function={changeDialogStatusMobileVerification}
                className="ConfirmBidDialog"
            >
                <h5 className="mt-3">
                    Please verify your mobile number to proceed with placing Offer or Making a
                    purchase.
                </h5>

                <div className="actionWrapper">
                    <Button id="cancel" onClick={() => setToggleDialogMobileVerification(false)}>
                        {t('Cancel')}
                    </Button>
                    <PrimaryButton
                        id="add_phone"
                        label="Continue"
                        btnSize="small"
                        onClick={() => handleRedirectInternal(history, 'my-account/personal')}
                    />
                </div>
            </CustomDialog>

            <Modal
                open={isBuyOpen}
                onClose={handleOpenBuy}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={style}>
                    <span className="close-this-icon" onClick={handleOpenBuy}>
                        &times;
                    </span>
                    <Typography id="modal-description" sx={{ mt: 2 }}>
                        <p className="mb-2">
                            Click &#34;Buy Now&#34; to add this item to your cart. The item is still
                            available for sale until you checkout.
                        </p>
                        <p className="learnMore mb-0">Learn more</p>
                        <Link href="/terms-and-conditions">
                            <span className="terms">Terms & Conditions</span>
                        </Link>
                    </Typography>
                </Box>
            </Modal>
        </>
    )
}

export default Buynow
